import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1a1a40', // Brand Purple
        secondary: '#c5a059', // Brand Gold
        accent: '#0f0f1a', // Brand Dark
        background: '#ffffff',
      },
    },
  },
});
